<neo-calendario #calendario
    [vista]="'month'"
    [configuracion]="[]"
    [deshabilitarDiasSinClaseEspecificada]="true"
    [botoneraAccionesCabecera]="[]"    
></neo-calendario>

<div *ngIf="fechaSeleccionada">Ha seleccionado el día {{fechaSeleccionada | date}}</div>